const typography = {
  fontFamily: ['Inter'].join(','),

  h1: {
    letterSpacing: '0.02em',
    fontSize: '3rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h2: {
    letterSpacing: '0.02em',
    fontSize: '2.25rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h3: {
    letterSpacing: '0.02em',
    fontSize: '2rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h4: {
    letterSpacing: '0.02em',
    fontSize: '1.875rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h5: {
    letterSpacing: '0.02em',
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h6: {
    letterSpacing: '0.02em',
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: 1.2,
  },
  subtitle1: {
    letterSpacing: '0.02em',
    fontSize: '1.2rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle2: {
    letterSpacing: '0.02em',
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  body1: {
    letterSpacing: '0.02em',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    letterSpacing: '0.02em',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  button: {
    letterSpacing: '0.02em',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  caption: {
    letterSpacing: '0.02em',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  overline: {
    letterSpacing: '0.02em',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
};

export default typography;
